import ImageBlock from './ImageSliderBlock';

export default ImageBlock;
